import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-generic-accordion-v2',
    templateUrl: './generic-accordion-v2.component.html',
    styleUrls: ['./generic-accordion-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenericAccordionV2Component implements OnInit, AfterViewInit {

  constructor(private appService: AppService, private breakpointObserver: BreakpointObserver, private cd: ChangeDetectorRef) { }
  @ViewChild('accordionContainer', {static: true, read: ElementRef}) accordionContainer: ElementRef;
  @Input() configData;
  @Input() frmGroup;
  isActive: boolean = false;
  isError: boolean = false;
  isHandset$: Observable<boolean> =
    this.breakpointObserver.observe(Breakpoints.HandsetPortrait)
      .pipe(
        map(result => result.matches),
        shareReplay()
      );

  ngOnInit() {
    if(this.configData.validation && this.configData.validation.length)      
      this.fieldValueValidation(this.configData.validation);
    this.isActive = this.configData.isActive;
  }

  getFormTableControls(index) {
    
    if(this.frmGroup.controls[this.configData.name].controls.length>1)
      return this.frmGroup.controls[this.configData.name]['controls'][index];
    else
      return this.frmGroup.controls[this.configData.name].controls[0];
  }
  ngAfterViewInit() {
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
    // To manually trigger change detection for template update from parent component
    this.appService.templateChangeSub.subscribe(data=>{
      if(data['templateChange']){
        this.cd.markForCheck();
      }
    })
  }
  getColsClass(cols: number[], control?: any) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    return colsClass;
  }
  toggleAccordian(event) {
    var element = event.target;
    element.classList.toggle("active");
    this.isActive = !this.isActive;
  }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        this.frmGroup.get(this.configData.name)['hidden'] = true;
        this.configData.required = false;
        this.frmGroup.get(this.configData.name).clearValidators();
        this.frmGroup.get(this.configData.name).updateValueAndValidity();
      }
    });
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    // this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    this.cd.markForCheck();
    // this.frmGroup.get(this.configData.name).reset();
    // this.frmGroup.get(this.configData.name).updateValueAndValidity();
  }

  accordionAction(action){
    console.log(action);
    if(action.type === 'AJAX'){
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        name: action.name,
        action : action.type,
        postData: this.frmGroup.get(this.configData.name),
        data: this.configData.accordionData ? this.configData.accordionData : '',
        command: action.command,
        rawAction: action
      })
    }
    console.log(this.frmGroup);
  }
}
